import React from 'react';

import { makeStyles } from 'tss-react/mui';

export { aiThreadIdVar } from './ai-thread-id';

const useAiDrawerStyles = makeStyles()(theme => ({
  footer: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(2),
    padding: theme.spacing(1, 2),
  },
  wrapper: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
}));

export function AIDrawerContainer({ children }: { children: React.ReactNode }): JSX.Element {
  const { classes } = useAiDrawerStyles();
  return <div className={classes.wrapper}>{children}</div>;
}

export function AIDrawerFooterContainer({ children }: { children: React.ReactNode }): JSX.Element {
  const { classes } = useAiDrawerStyles();
  return <div className={classes.footer}>{children}</div>;
}
